import { computed, ComputedRef, Ref } from '@nuxtjs/composition-api';
import { Product } from '~/modules/catalog/product/types';
import { Product3DEntryInterface } from '~/modules/catalog/product/composables/useProduct3D/useProduct3D';
import { ProductImage, useImage } from '~/composables';

function getGalleryImage(img: ProductImage) {
  const { getMagentoImage } = useImage();
  return {
    mobile: { url: getMagentoImage(img.url) },
    desktop: { url: getMagentoImage(img.url) },
    big: { url: getMagentoImage(img.url) },
    alt: img.label,
    placeholder: img.label,
  };
}

export function useProduct3D(product: Ref<Product>): ComputedRef<Product3DEntryInterface[]> {
  return computed(() => {
    const entries = [];
    if (product.value.product3d_model) {
      entries.push({
        product3DImage: getGalleryImage(product.value.product3d_image),
        product3DModel: product.value.product3d_model,
      });
    }
    return entries;
  });
}
